import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { NotificationProvider, addNotificationEvent } from 'shared/components'
import { store } from 'store'

import App from './App'
import reportWebVitals from './reportWebVitals'
import axios from 'axios'

// Ниже настройки на будущее :)
// axios.defaults.baseURL = process.env.REACT_APP_API_URL
// axios.interceptors.request.use(request => {
//   return request
// })

axios.interceptors.response.use(
  response => response,
  error => {
    const errorMsg =
      error.response?.data?.Message ||
      error.response?.data?.message ||
      'Извините, произошла ошибка'

    addNotificationEvent({
      type: 'error',
      description: errorMsg,
    })
    return Promise.reject(error)
  }
)

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <GoogleReCaptchaProvider
        reCaptchaKey="6Lcxqi8qAAAAABLKaJWUC9dfGfyT3wFVdDXG48r1"
        scriptProps={{
          appendTo: 'body',
        }}
      >
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </GoogleReCaptchaProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
